/** @format */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";
import App from "./App.tsx";
import "./index.css";
import { registerPostHogSuperProperties } from "./lib/posthog";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    // tunnel: "/api/sentry-tunnel", // TODO: Uncomment this when we have a sentry tunnel
    environment: import.meta.env.VITE_ENV ?? import.meta.env.MODE,
    release: import.meta.env.VITE_RELEASE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  });
}

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: import.meta.env.VITE_POSTHOG_HOST ?? "https://us.i.posthog.com",
    capture_pageview: true,
    person_profiles: "identified_only",
    advanced_disable_flags: true,
  });
  registerPostHogSuperProperties();
}

const root = (
  <StrictMode>
    <Sentry.ErrorBoundary>
      {posthogKey ? (
        <PostHogProvider client={posthog}>
          <App />
        </PostHogProvider>
      ) : (
        <App />
      )}
    </Sentry.ErrorBoundary>
  </StrictMode>
);

createRoot(document.getElementById("root")!).render(root);
